import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import axios from "axios";
import React, { useEffect, useState } from "react";
import getDate from "../../../utils/getDate";

import { faAddressCard } from "@fortawesome/free-solid-svg-icons";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import gem from "../../../../assets/trophy/gem_orange.png";
import Loading from "../../../Loading/Loading";
import auth from "./../../../../firebase.init";
import useAdmin from "./../../../hooks/useAdmin";
import useAssistant from "./../../../hooks/useAssistant";
import asmaulhusnaCompletion from "./Functions/asmaulhusnaCompletion";
import asmaulhusnaGemsUpdater from "./Functions/asmaulhusnaGemsUpdater";

const AsmaulHusnaAdminAccessRow = ({
  student,
  batch,
  module_no,
  completion,
  updateSignal,
  setUpdateSignal,
}) => {
  const [user, loading, error] = useAuthState(auth);
  const [admin] = useAdmin(user);
  const [assistant] = useAssistant(user);

  const [bloop, setBloop] = useState(false);
  const [clickCount, setClickCount] = useState(0);
  const navigate = useNavigate();

  const loadDetails = (e) => {
    navigate(`/asmaul-husna-${batch}/${student?.sn}`, {
      state: { id: 1, batch: batch, student: student },
    });
  };

  useEffect(() => {
    setClickCount(0);
    const date = getDate(new Date());
    if (student?.todaysinfo?.date < date) {
      const data = {
        date: date,
      };
      axios
        .put(
          `${process.env.REACT_APP_BACKEND_API}/asmaulhusna/date/update/${batch}/${student?.sn}`,
          data
        )
        .then((data) => {
          setUpdateSignal(updateSignal + 1);
        });
    }
  }, [student, module_no]);

  const updateModule = async () => {
    const update_module = student?.dua[module_no];

    if (!admin && !assistant) return;
    if (update_module === 1) return;
    if (bloop) return;
    setClickCount(clickCount + 1);

    if (clickCount === 0) {
      if (student?.todaysinfo?.dua === 0) {
        await setBloop(true);
        await asmaulhusnaGemsUpdater(student?.gems, batch, student?.sn);
      }
    }
    const data = {
      index: module_no,
    };
    // console.log("completion", completion);

    await axios
      .put(
        `${process.env.REACT_APP_BACKEND_API}/asmaulhusna/dua_update/${batch}/${student?.sn}`, //http://localhost:5000
        data
      )
      .then((data) => {
        asmaulhusnaCompletion(batch, student?.sn, completion);
        setUpdateSignal(updateSignal + 1);
      });
    await setBloop(false);
    toast.success(`${student?.name.toUpperCase()} Updated!`);
  };

  if (!student) {
    return <Loading></Loading>;
  }

  if (bloop) {
    console.log("blooping");
  }
  return (
    <tr className="hover">
      <th>{student?.sn}</th>
      <td>{student?.name?.toUpperCase()}</td>
      <td>
        {!student?.dua[module_no] && !clickCount && (
          <FontAwesomeIcon
            className="text-2xl text-blue-600 cursor-pointer"
            icon={faCheckCircle}
            onClick={updateModule}
          ></FontAwesomeIcon>
        )}
      </td>

      <td>
        {/* <FontAwesomeIcon icon={faUser} /> */}
        <FontAwesomeIcon
          icon={faAddressCard}
          onClick={loadDetails}
          className="text-2xl text-green-600 cursor-pointer"
        />
      </td>
      <td className="flex">
        {student?.gems}{" "}
        <img
          className={`ml-2 w-4 ${bloop ? "animate-bounce" : ""}`}
          src={gem}
          alt="diamond icon"
        />
      </td>
    </tr>
  );
};

export default AsmaulHusnaAdminAccessRow;
